import { createSlice } from '@reduxjs/toolkit';
import { DashboardTile } from '../../pages/Dashboard/Dashboard.types';

export interface TabExamTaskGroupSolutionScore {
  id: string;
  sheetId: string;
  examinerId: string;
}

export interface AssessmentSessionState {
  assessmentSession: DashboardTile | null;
  tabExamTaskGroupSolutionScores: TabExamTaskGroupSolutionScore[];
}

const initialState: AssessmentSessionState = {
  assessmentSession: null,
  tabExamTaskGroupSolutionScores: [],
};

const assessmentSessionSlice = createSlice({
  name: 'assessmentSession',
  initialState,
  reducers: {
    updateAssessmentSession: (state, action: { type: string; payload: DashboardTile | null }) => {
      return { ...state, assessmentSession: action.payload };
    },
    startTabScoring: (
      state,
      action: {
        type: string;
        payload: TabExamTaskGroupSolutionScore[];
      },
    ) => {
      return {
        ...state,
        tabExamTaskGroupSolutionScores: action.payload,
      };
    },
  },
});

export const assessmentSessionActions = assessmentSessionSlice.actions;
export default assessmentSessionSlice;
